import axios from "axios";
import Cookies from "js-cookie";

// Use the user's provided backend URL (not from .env)
// Backend URL
const baseURL = process.env.REACT_APP_API_URL || "https://backend.rainbitx.com";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Attach Authorization header from cookie if present
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken") || Cookies.get("authToken") || Cookies.get("adminToken") || null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Simple response interceptor (can be extended for refresh token logic)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    Cookies.set("accessToken", token, { expires: 7, secure: true, sameSite: 'strict' });
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
    Cookies.remove("accessToken");
  }
};

export default axiosInstance;
